'use client';

import { c as _c } from "react/compiler-runtime";
import { FormControl, FormControlLabel, FormHelperText, Label, Radio, RadioGroup } from '@internations/ds';
import { Field, useField, useFormikContext } from '@util/Formik';
import type { JSX } from 'react';
import { BaseSyntheticEvent } from 'react';
const RegistrationGenderPicker = () => {
  const $ = _c(19);
  const [, t0] = useField("gender");
  const {
    touched,
    error
  } = t0;
  const {
    handleChange,
    setFieldValue
  } = useFormikContext();
  let t1;
  if ($[0] !== handleChange || $[1] !== setFieldValue) {
    t1 = e => {
      setFieldValue("gender", true);
      handleChange(e);
    };
    $[0] = handleChange;
    $[1] = setFieldValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onChange = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Label htmlFor="gender" gutterBottom={true}>Gender</Label>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = Boolean(touched && error);
  let t4;
  if ($[4] !== onChange) {
    t4 = <FormControlLabel value="male" control={<Field type="radio" as={Radio} name="gender" value="m" onChange={onChange} />} data-testid="gender-male" label="Male" />;
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onChange) {
    t5 = <FormControlLabel value="female" control={<Field type="radio" as={Radio} name="gender" value="f" onChange={onChange} />} data-testid="gender-female" label="Female" />;
    $[6] = onChange;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex flex-row">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = Boolean(touched && error) && error;
  let t8;
  if ($[11] !== t7) {
    t8 = <FormHelperText>{t7}</FormHelperText>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <RadioGroup aria-label="gender" id="gender">{t6}{t8}</RadioGroup>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t9) {
    t10 = <>{t2}<FormControl component="fieldset" error={t3}>{t9}</FormControl></>;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default RegistrationGenderPicker;